import * as R from 'ramda'

import installModel from './db/installClient.js'
import installView from './view/installClient.js'

export default R.pipe(installModel, installView)
